export const types = {
        SET_NAVIGATION_TITLE: "SET/NAVIGATION_TITLE" 
  };
  export const setNavigationTitle = (title, homelink) => ({
    type: types.SET_NAVIGATION_TITLE,
    title,
    homelink
  });
  